import { BillableRateResponse } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/configuration-local-accounting-billable-rates/billable-rate.dto'
import { StrictNullable } from '@/shared/types/app.types'

export enum ConfigurationLocalAccountingRatesModalTabIndex {
    BASIC = 0,
    CONCEPTS = 1
}

export interface ConfigurationLocalAccountingRatesModalState {
    rate: StrictNullable<BillableRateResponse>
    showConceptsTab: boolean
    activeTabIndex: number
    actionTitle: string
    showModal: boolean
}
export const initialConfigurationLocalAccountingRatesModalState =
    (): ConfigurationLocalAccountingRatesModalState => ({
        rate: null,
        showConceptsTab: false,
        activeTabIndex: ConfigurationLocalAccountingRatesModalTabIndex.BASIC,
        actionTitle: '',
        showModal: false
    })
